export default __webpack_public_path__ + "static/media/WNo.8-1.e7dc6563.jpg";